import { createContext, useContext, useEffect, useState, ReactNode } from 'react'
import { DeploymentConfig, fetchDeploymentConfig } from '@/api/deployment'

export const DeploymentConfigCtx = createContext<DeploymentConfig | null>(null)
const Ctx = DeploymentConfigCtx

export function DeploymentConfigProvider({ children }: { children: ReactNode }) {
  const [config, setConfig] = useState<DeploymentConfig | null>(null)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    let cancelled = false
    fetchDeploymentConfig()
      .then((c) => { if (!cancelled) setConfig(c) })
      .catch((e) => { if (!cancelled) setError(e) })
    return () => { cancelled = true }
  }, [])

  if (error) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        gap: '1rem',
        fontFamily: 'sans-serif',
      }}>
        <h1>Konfiguration konnte nicht geladen werden</h1>
        <p style={{ color: '#666', maxWidth: '40rem', textAlign: 'center' }}>
          {error.message}
        </p>
        <button onClick={() => location.reload()} style={{ padding: '0.5rem 1rem' }}>
          Neu laden
        </button>
      </div>
    )
  }

  if (!config) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        fontFamily: 'sans-serif',
      }}>
        <span>Lade Konfiguration…</span>
      </div>
    )
  }

  return <Ctx.Provider value={config}>{children}</Ctx.Provider>
}

export function useDeploymentConfig(): DeploymentConfig {
  const config = useContext(Ctx)
  if (!config) {
    throw new Error('useDeploymentConfig must be used inside DeploymentConfigProvider')
  }
  return config
}

export function applyPlaceholders(
  template: string,
  vars: { companyName: string; jobTitle: string },
): string {
  return template
    .replace(/\{company\}/g, vars.companyName)
    .replace(/\{job_title\}/g, vars.jobTitle)
}